<template>
  <div class="flow-chart conmon-top">
    <!--上部名字以及操作按钮集合-->
    <div class="info-operation">
      <div class="flow-chart-name">
        {{ flowName }}
        <i @click="openEditFirst" class="iconfont icon-icon-bianji" style="color: #4DA2ED;font-size: 16px;margin-left: 10px;cursor: pointer"></i>
      </div>
      <div class="flow-chart-opertions">
        <div v-if="btnJudge === 1 || btnJudge === 3" @click="doThis">
          <i class="iconfont icon-qidong" style="color: #4DA2ED"></i>
          <span style="color: #4DA2ED">启用</span>
        </div>
        <div v-if="btnJudge === ''" @click="saveFlowChart">
          <i class="iconfont icon-ZHicon_huaban" style="color: #4DA2ED"></i>
          <span style="color: #4DA2ED">保存</span>
        </div>
        <div v-if="btnJudge === 1 || btnJudge === 3" @click="saveEdit">
          <i class="iconfont icon-ZHicon_huaban editColor"></i>
          <span class="editColor">确认编辑</span>
        </div>
        <div v-if="btnJudge === 2" @click="stopThis">
          <i class="iconfont icon-tingzhi" style="color: red"></i>
          <span style="color: red">停止</span>
        </div>
        <div v-if="btnJudge === 1 || btnJudge === 3" @click="deleteThis">
          <i class="iconfont icon-icon-shanchu" style="color: red"></i>
          <span style="color: red">删除</span>
        </div>
      </div>
    </div>
    <p class="flow-name">流程图</p>
    <div ref="mountNode" id="mountNode"></div>
    <!--node弹窗-->
    <div class="auto-process-model">
      <el-dialog class="cellDialog" :visible.sync="chooseNode" @close="closeNodeDialog" width="500px">
        <div class="model">
          <div class="top-nav" v-if="isShow === true">
            <div v-for="(item, index) in navs" @click="changeTabs(index)" :key="index" :class="tabIndex == index ? specialClass : ''">{{ item }}</div>
          </div>
          <div class="bottom-content" v-if="nodeShow === true">
            <div v-if="tabIndex === 0" @click="changeAction(index)" v-for="(item, index) in nodeActions" :key="index" class="node-item node-item-one">
              <div :class="item.class" class="node-item-icon"></div>
              <div>{{ item.name }}</div>
            </div>
            <div v-if="tabIndex === 1" @click="changeJudge(index)" v-for="(item, index) in nodeConditions" :key="index" class="node-item node-item-two">
              <div :class="item.class" class="node-item-icon" style="background: #D893F2"></div>
              <div>{{ item.name }}</div>
            </div>
            <div v-if="tabIndex === 2" @click="changeControl(index)" v-for="(item, index) in nodeProcess" :key="index" class="node-item node-item-three">
              <div :class="item.class" class="node-item-icon" style="background: #FF8888"></div>
              <div>{{ item.name }}</div>
            </div>
          </div>
          <!--动作-->
          <customer-attribute :contents="customerAttrContent" @change="getCustomerAttr" v-if="nodeAction === 2" style="margin-top: 20px"></customer-attribute>
          <add-group :contents="addGroupContent" @change="getAddGroup" v-if="nodeAction === 3" style="margin-top: 20px"></add-group>
          <remove-group :contents="removeGroupContent" @change="getRemoveGroup" v-if="nodeAction === 4" style="margin-top: 20px"></remove-group>
          <template-message :contents="templateMessageContent" @change="getTemplateMessage" v-if="nodeAction === 5" style="margin-top: 20px"></template-message>
          <send-red-packets :contents="sendRedPacketsContent" @change="getSendRedPackets" v-if="nodeAction === 6" style="margin-top: 20px"></send-red-packets>
          <wechatReply :contents="wechatReplyContent" @transform="getWechatReply" v-if="nodeAction === 0" style="margin-top: 20px"></wechatReply>
          <message :contents="smsContent" @change="getSmsChoose" v-if="nodeAction === 1" style="margin-top: 20px"></message>
          <!--条件判断-->
          <event-judge :contents="eventsContent" @change="getEvents" v-if="nodeJudge === 1" style="margin-top: 20px"></event-judge>
          <attribute-branch :contents="attrBranchContent" @change="getAttrBranch" v-if="nodeJudge === 2" style="margin-top: 20px"></attribute-branch>
          <attrJudge :contents="attrJudgeContent" @sendSearchTerms="getSearchTerms" v-if="nodeJudge === 0" style="margin-top: 20px"></attrJudge>
          <!--流程控制-->
          <wait :contents="waitTime" @getWait="getWait" v-if="nodeControl === 0" style="margin-top: 20px"></wait>
          <end @change="getEnd" v-if="nodeControl === 1" style="margin-top: 20px"></end>
        </div>
        <div v-if="nodeAction !== '' || nodeJudge !== '' || nodeControl !== ''" slot="footer" class="dialog-footer" style="margin-top: 10px">
          <el-button class="dialog-cancel-btn" @click="chooseNode = false" style="margin-left: 20px">取 消</el-button>
          <el-button class="dialog-confirm-btn" v-if="btnJudge !== 2" type="primary" @click="confirmAddNode">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!--流程第一步的编辑弹窗-->
    <el-dialog class="cellDialog" @close="closeFirstStep" title="自动流程开始条件" :visible.sync="createdAutoProcressDialog" width="520px">
      <div>
        <!--实时-->
        <el-form v-if="startType === 0" ref="flowChartForm" :model="flowChartForm">
          <el-form-item label-width="70px" label="发送群组" class="stockInputs">
            <el-select filterable v-model="flowChartForm.queryGroup" placeholder="请选择发送群组" class=""
                       style="width: 340px">
              <el-option
                v-for="item in targetGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id" style="width: 340px">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="70px" label="流程名称" style="margin-bottom: 10px;">
            <el-input  v-model="flowChartForm.procressName" style="width: 340px;"></el-input>
          </el-form-item>
          <el-form-item label-width="70px" label="触发条件">
            <el-radio-group v-model="selectRadio" @change="selectRadioChange">
              <el-radio :label="0">事情发生</el-radio>
              <el-radio :label="1">活跃度变化</el-radio>
              <el-radio :label="2">属性变化</el-radio>
            </el-radio-group>
            <!-- 事情发生 -->
            <div v-if="selectRadio === 0">
              <el-row>
                <el-col style="width: 250px; margin-left: 40px;">
                  <el-checkbox v-model="checked" style="float: left;">允许同一用户重复进入</el-checkbox>
                  <el-cascader
                    v-model="selectedOptions"
                    :options="activityOptions"
                    @change="activitySelectChange"
                    style="margin-bottom: 10px; width: 340px; margin-left: 0px;">
                  </el-cascader>
                  <el-select filterable v-model="subSelectedEvent" v-show="eventSelectShow" style="width: 340px;">
                    <el-option
                      v-for="i in eventChangeOptions"
                      :key="i.value"
                      :label="i.label"
                      :value="i.value" style="width: 340px">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <!-- 客户活跃度 -->
            <div v-if="selectRadio === 1">
              <el-row>
                <el-col style="width: 250px; margin-left: 40px;">
                  <!--<el-select v-model="selectActivityChange" placeholder="请选择活跃度类型" style="width: 340px; margin-bottom: 10px;">-->
                    <!--<el-option-->
                      <!--v-for="item in activityChangeOptions"-->
                      <!--:key="item.value"-->
                      <!--:label="item.label"-->
                      <!--:value="item.value">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                  <el-select v-model="selectUpAndDown" style="width: 340px; margin-bottom: 10px;">
                    <el-option
                      v-for="item in selectUpAndDownOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-input-number  class="auto-process-act-changes" controls-position="right" :min="-1000000000" :max="1000000000000" v-model="activityNum" style="margin-bottom: 10px; width: 340px;"  placeholder="请输入活跃度"></el-input-number>
                </el-col>
              </el-row>
            </div>
            <!-- 属性变化 -->
            <div v-if="selectRadio === 2">
              <el-row>
                <el-col style="width: 250px;margin-left: 40px">
                  <el-checkbox v-model="attributeSelect" style="float: left;">允许同一用户重复进入</el-checkbox>
                  <el-cascader
                    :options="attributeOptions"
                    v-model="attrSelectedOptions"
                    @change="selectAttributeChange"
                    :show-all-levels="false" style="margin-bottom: 10px; width: 340px;">
                  </el-cascader>
                  <el-select v-model="relationSelect" style="width: 340px; margin-bottom: 10px;">
                    <el-option
                      v-for="item in relationOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div v-if="controlType === 'select'">
                    <el-select v-model="selectAttribute" style="width: 340px; margin-bottom: 10px;">
                      <el-option
                        v-for="item in selectOptions"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="controlType === 'radio'">
                    <el-select v-model="selectAttribute" style="width: 340px; margin-bottom: 10px;">
                      <el-option
                        v-for="item in selectOptions"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <el-input v-model="selectAttribute" style="margin-bottom: 10px; width: 340px;" v-if="controlType === 'input'"></el-input>
                  <el-cascader
                    v-if="controlType === 'addressPicker'"
                    style="width: 340px;"
                    size="large"
                    :options="addressOptions"
                    v-model="selectAttribute">
                  </el-cascader>
                  <el-date-picker
                    v-if="controlType === 'datePicker'"
                    v-model="selectAttribute"
                    type="date"
                    placeholder="选择日期"
                    style="width: 340px;">
                  </el-date-picker>
                  <el-date-picker
                    v-if="controlType === 'dateTimePicker'"
                    v-model="selectAttribute"
                    type="datetime"
                    class="dateTimePicker"
                    placeholder="选择时间和日期">
                  </el-date-picker>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
        </el-form>
        <!--单次-->
        <el-form v-if="startType === 1" ref="flowChartForm" :model="flowChartForm">
          <el-form-item label-width="70px" label="发送群组" class="stockInputs">
            <el-select filterable v-model="flowChartForm.queryGroup" placeholder="请选择发送群组" class="" style="width: 340px">
              <el-option
                v-for="item in targetGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="70px" label="流程名称" style="margin-bottom: 10px;">
            <el-input  v-model="flowChartForm.procressName" style="width: 340px;"></el-input>
          </el-form-item>
        </el-form>
        <!--周期性-->
        <el-form v-if="startType === 2" ref="flowChartForm" :model="flowChartForm">
          <el-form-item label-width="70px" label="发送群组" class="stockInputs">
            <el-select filterable v-model="flowChartForm.queryGroup" placeholder="请选择发送群组" class="" style="width: 340px">
              <el-option
                v-for="item in targetGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="70px" label="流程名称" style="margin-bottom: 10px;">
            <el-input  v-model="flowChartForm.procressName" style="width: 340px;"></el-input>
          </el-form-item>
          <el-form-item label-width="70px" label="时间设置" style="margin-bottom: 5px;border-bottom: 1px solid #ddd">
            <el-radio-group v-model="dateRadio" @change="dateChange">
              <el-radio :label="1">按天</el-radio>
              <el-radio :label="2">按周</el-radio>
              <el-radio :label="3">按月</el-radio>
              <el-radio :label="4">按年</el-radio>
            </el-radio-group>
          </el-form-item>
          <DateTemplateEdit @change="getValue" :dateType="dayRadio" :timeShow="timeShow" style="margin-left: 30px;" ></DateTemplateEdit>
          <el-form-item label-width="70px" label="具体时间" style="margin-top: 20px;margin-bottom: 0">
            <el-time-picker
              arrow-control
              style="width: 340px"
              v-model="realTime"
              placeholder="请选择时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label-width="70px" class="start-end-time" label="起止时间" style="margin-top: 5px;">
            <el-date-picker
              v-model="startEnd"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00']"
              style="width: 340px; margin-top: 10px;">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="btnJudge !== 2" style="color: #333"><span style="color: red">*</span>修改第一步，暂存之后请点击保存进行修改</div>
      <div slot="footer" v-if="btnJudge !== 2" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" style="margin-left: 20px" @click="cancelFirstStep">取 消</el-button>
        <el-button type="primary" class="dialog-confirm-btn" style="margin-right: 32px" @click="saveFirstStep">暂 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { autoFlowWechatReply, getBigWheelList, getFlowChartDetail, changeFlowChartStatus, deleteAutomation, editFlowChart, getGroupList, getCustomerAttributeList, getMessageList, saveFlowChart, getFlowChart, getWechatPublicListForNode, getWePagesListForNode, getMessageGroupList, getEventList } from '@/api/customer.js'
import 'G6'
import '../../assets/js/g6-node'
import '../../assets/css/g6-node.css'
import wechatReply from './../auto-process-components/wechat-reply.vue'
import templateMessage from './../auto-process-components/template-message.vue'
import removeGroup from './../auto-process-components/remove-group.vue'
import customerAttribute from './../auto-process-components/customer-attribute.vue'
import addGroup from './../auto-process-components/add-group.vue'
import sendRedPackets from './../auto-process-components/send-red-packets.vue'
import message from './../auto-process-components/message.vue'
import attrJudge from './../auto-process-components/attr-judge.vue'
import eventJudge from './../auto-process-components/event-judge.vue'
import attributeBranch from './../auto-process-components/attribute-branch.vue'
import wait from './../auto-process-components/wait.vue'
import end from './../auto-process-components/end.vue'
import { toArray, toTree, removeNode } from '../../assets/js/g6-tool'
import { mapMutations, mapGetters } from 'vuex'
import DateTemplateEdit from '../common/date-template-edit.vue'
export default {
  name: 'minimap',
  data () {
    return {
      isHvaeData: false,
      isFirst: true,
      firstStep: {},
      timeShow: {
        weekNum: '',
        dayNum: '',
        monthNum: '',
        dayOne: 1,
        yearDayNum: ''
      },
      realTime: '',
      startEnd: '',
      startType: '',
      timeValue: {},
      dayRadio: 1,
      dateRadio: 1,
      addressOptions: regionDataPlus,
      selectOptions: [],
      selectAttribute: '',
      controlType: '',
      relationOptions: [
        {
          id: 1,
          value: '=',
          label: '等于'
        },
        {
          id: 2,
          value: '!=',
          label: '不等于'
        },
        {
          id: 3,
          value: 'contain',
          label: '包含'
        },
        {
          id: 4,
          value: 'not contain',
          label: '不包含'
        },
        {
          id: 5,
          value: 'empty',
          label: '为空'
        },
        {
          id: 6,
          value: 'not empty',
          label: '不为空'
        }
      ],
      relationSelect: '',
      attrSelectedOptions: [],
      attributeOptions: [],
      attributeSelect: false,
      activityNum: '',
      selectUpAndDown: '',
      selectUpAndDownOptions: [
        {
          value: '=',
          label: '等于'
        }, {
          value: '>',
          label: '大于'
        }, {
          value: '<',
          label: '小于'
        }
      ],
      activityChangeOptions: [
        {
          value: 1,
          label: '客户活跃度'
        },
        {
          value: 2,
          label: '客户7天活跃度'
        },
        {
          value: 3,
          label: '客户30天活跃度'
        }
      ],
      selectActivityChange: '',
      eventSelectShow: true,
      eventChangeOptions: [],
      subSelectedEvent: '',
      activityOptions: [],
      selectedOptions: [],
      checked: false,
      selectRadio: 0,
      targetGroups: [],
      flowChartForm: {
        queryGroup: '',
        procressName: ''
      },
      addLabelWidth: '80px',
      flowName: '',
      createdAutoProcressDialog: false,
      idArray: [],
      isShow: true,
      specialClass: 'active-one',
      chooseNode: false,
      navs: ['动作', '条件控制', '流程控制'],
      tabIndex: 0,
      nodeActions: [
        {
          name: '微信回复',
          class: 'iconfont icon-wechat'
        },
        {
          name: '短信',
          class: 'iconfont icon-duanxin'
        },
        {
          name: '客户属性',
          class: 'iconfont icon-kehu'
        },
        {
          name: '加入群组',
          class: 'iconfont icon-jiarubanji'
        },
        {
          name: '移出群组',
          class: 'iconfont icon-huiyuanyichu'
        },
        {
          name: '模板消息',
          class: 'iconfont icon-navicon-dxmbwh'
        },
        {
          name: '发送红包',
          class: 'iconfont icon-hongbao'
        }
      ],
      nodeConditions: [
        {
          name: '属性判断',
          class: 'iconfont icon-gongrenshuxing'
        },
        {
          name: '事件判断',
          class: 'iconfont icon-shijianguanli'
        },
        {
          name: '属性多分支',
          class: 'iconfont icon-84'
        }
      ],
      nodeProcess: [
        {
          name: '等待',
          class: 'iconfont icon-dengdai'
        },
        {
          name: '结束',
          class: 'iconfont icon-zhaobiaojieshu'
        }
      ],
      nodeShow: true,
      nodeAction: '',
      nodeJudge: '',
      nodeControl: '',
      smsContent: {
        id: '',
        name: '短信',
        template_id: ''
      }, // 短信传过来的值
      wechatReplyContent: {
        name: '微信回复',
        wechatId: '',
        contentType: 'text',
        content: '',
        wePage: '',
        link: '',
        title: '',
        main: '',
        id: ''
      }, // 微信回复传过来的值
      customerAttrContent: {
        attrId: '',
        attrVal: null,
        name: '客户属性',
        id: ''
      }, // 客户属性传过来的值
      addGroupContent: {
        name: '加入群组',
        addGroupId: '',
        id: ''
      }, // 加入群组传过来的值
      removeGroupContent: {
        name: '移除群组',
        removeGroupId: '',
        id: ''
      }, // 移出群组传过来的值
      templateMessageContent: {
        name: '模板消息',
        wechatPublicId: '',
        messageId: '',
        id: '',
        useList: []
      }, // 模板消息传过来的值
      sendRedPacketsContent: {
        wechatId: '',
        sendMessage: '发送红包',
        name: '',
        remark: '',
        activityName: '',
        goodLuck: '',
        num: 0,
        id: ''
      }, // 发送红包传过来的值
      attrJudgeContent: {
        nodeType: '',
        id: '',
        allTerms: {
          allRelationship: 'and',
          termsGroup: [
            {
              inOperator: 'and',
              terms: [
                {
                  attr: 'attr',
                  relationship: '',
                  value: null,
                  selectedOptions: ['attr', 'realname@input'],
                  secAttr: 'realname'
                }
              ]
            }
          ]
        }
      }, // 属性判断传过来的值
      eventsContent: {
        day: 0,
        hours: 0,
        nodeType: '',
        mins: 0,
        id: '',
        content: [
          {
            conditionIndex: 1,
            selectedOptions: [],
            selectShow: true,
            subSelectedOptions: '',
            changeOptions: []
          }
        ]
      }, // 事件判断传过来的值
      attrBranchContent: {
        id: '',
        attrId: '',
        conditionValue: '',
        nodeType: '',
        content: [
          {
            branchIndex: 1,
            value: ''
          }
        ]
      }, // 属性多分支传过来的值
      waitTime: {
        waitType: 0,
        day: 0,
        hours: 0,
        mins: 0,
        confirmTime: '',
        relatime: '',
        id: ''
      }, // 等待传过来的值
      endContent: {
        id: '',
        nodeType: 'endNode'
      }, // 结束传过来的值
      graph: null,
      modules: [], // 功能模块
      nodeType: '', // 节点类型
      speNodeType: '',
      evs: {},
      recordDialog: {},
      openWay: 2, // 弹窗打开方式
      treeDataArr: [
        {
          id: 'start',
          shape: 'start',
          parent: ''
        },
        {
          id: 'add',
          shape: 'addNodeBtn',
          parent: 'start'
        }
      ],
      treeDataArrCopy: [],
      startCondition: {},
      evAttrBranch: {},
      btnJudge: ''
    }
  },
  mounted () {
    const layout = new G6.Layouts.CompactBoxTree({ direction: 'TB' })
    this.graph = new G6.Tree({
      container: 'mountNode',
      width: this.$refs.mountNode.width,
      height: 500,
      fitView: 'tc',
      layout
    })
    // 箭头
    if (this.speNodeType !== 'endNode') {
      this.graph.edge({
        style: {
          endArrow: true
        }
      })
    }
    // 节点透明
    this.graph.node({
      style: {
        // 关键形样式（优先级高于color）
        fill: 'transparent',
        stroke: 'transparent'
      }
    })
    // 添加
    // this.graph.on('node:click', ev => {
    // this.addCond(ev, [1, 2, 3])
    // })
    // 拖动处理
    this.drag()
    // 点击处理
    this.click()
    // 渲染流程图
    this.render()
  },
  computed: {
    ...mapGetters([
      'getConditions'
    ]),
    graphData() {
      let nodes = [{
        id: 'first', // id 必须唯一
        color: '#333', // 颜色
        size: 100, // 尺寸 || [宽, 高]
        shape: 'start', // 所用图形
        index: 1, // 渲染层级
        style: { // 关键形样式（优先级高于color）
          fill: 'transparent',
          stroke: 'transparent'
        }
      }, {
        id: 'first2',
        y: 200,
        shape: 'addNodeBtn', // 所用图形
        style: { // 关键形样式（优先级高于color）
          fill: 'transparent',
          stroke: 'transparent'
        }
      }]
      return {
        nodes: nodes
      }
    }
  },
  updated() {
    this.$nextTick(function() {
      let _this = this
      _this.graph.on('node:click', ev => {
        // 点击微信回复编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-wechat') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 0
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.wechatReplyContent = item.content
            }
          }
        }
        // 点击短信编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-duanxin') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 1
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.smsContent = item.content
            }
          }
        }
        // 点击客户属性编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-kehu') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 2
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.customerAttrContent = item.content
            }
          }
        }
        // 点击加入群组编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-jiarubanji') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 3
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.addGroupContent = item.content
            }
          }
        }
        // 点击移出群组编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-huiyuanyichu') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 4
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.removeGroupContent = item.content
            }
          }
        }
        // 点击模板消息编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-navicon-dxmbwh') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 5
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.templateMessageContent = item.content
            }
          }
        }
        // 点击发送红包编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-hongbao') {
          this.recordDialog.type = 'nodeAction'
          this.recordDialog.value = 6
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.sendRedPacketsContent = item.content
            }
          }
        }
        // 点击属性判断编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-gongrenshuxing') {
          this.recordDialog.type = 'nodeJudge'
          this.recordDialog.value = 0
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.attrJudgeContent = item.content
            }
          }
        }
        // 点击事件判断编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-shijianguanli') {
          this.recordDialog.type = 'nodeJudge'
          this.recordDialog.value = 1
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.eventsContent = item.content
            }
          }
        }
        // 点击属性多分支判断编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-84') {
          this.recordDialog.type = 'nodeJudge'
          this.recordDialog.value = 2
          this.isWhatNode(ev)
          this.evAttrBranch = ev
          console.log('evAttrBranch', this.evAttrBranch)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.attrBranchContent = item.content
            }
          }
        }
        // 点击等待编辑
        if (ev.domEvent.target.className === 'node-item-icon iconfont icon-dengdai') {
          this.recordDialog.type = 'nodeControl'
          this.recordDialog.value = 0
          this.isWhatNode(ev)
          for (let item of this.treeDataArr) {
            if (item.id === ev.item.id) {
              this.waitTime = item.content
            }
          }
        }
        // 如果是点击删除x 则删除本节点和他以下的节点
        if (ev.domEvent.target.className === 'el-icon-close closeBtn') {
          _this.treeDataArr = removeNode(_this.treeDataArr, ev.item.id)
          _this.render()
        }
      })
    })
  },
  methods: {
    // 关闭节点弹窗
    closeNodeDialog() {
      this.nodeAction = ''
      this.nodeJudge = ''
      this.nodeControl = ''
    },
    // 关闭开始节点的编辑弹窗
    closeFirstStep() {
      let id = this.$route.query.id
      this.createdAutoProcressDialog = false
      if (id) {
        if (this.isFirst === true) {
          this.firstStep = {}
          this.getActualData()
        }
      }
    },
    // 关闭开始节点的编辑弹窗
    cancelFirstStep() {
      let id = this.$route.query.id
      this.createdAutoProcressDialog = false
      if (id) {
        if (this.isFirst === true) {
          this.firstStep = {}
          this.getActualData()
        }
      }
    },
    // 停止流程
    stopThis() {
      let id = this.$route.query.id
      this.$confirm('你确定要停止当前自动流程吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeFlowChartStatus(id, 3).then((res) => {
          if (res.data.code === 0) {
            this.getActualData()
            _g.toastMsg('success', '停止成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 启动流程
    doThis() {
      let id = this.$route.query.id
      this.$confirm('启动自动流程前请仔细检查流程的各项设置，你确定要启动吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeFlowChartStatus(id, 2).then((res) => {
          if (res.data.code === 0) {
            this.getActualData()
            _g.toastMsg('success', '启用成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 删除流程
    deleteThis() {
      let id = this.$route.query.id
      this.$confirm('确认删除该流程?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAutomation(id).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除流程成功')
            router.push('/home/auto-process')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    dateChange() {
      this.dayRadio = this.dateRadio
    },
    // 获取子组件的值
    getValue(value) {
      this.timeValue = value
    },
    // 获取客户属性
    getCustomerAttributeList() {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            if (data[i].identity === 'district' || data[i].identity === 'city' || data[i].identity === 'province' || data[i].identity === 'country' || data[i].identity === 'stage_id' || data[i].identity === 'source_id') {
              continue
            }
            if (data[i].is_system === 0) {
              continue
            }
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity // + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          remainData.push({
            label: '省市区',
            value: 'addressPicker',
            identity: 'addressPicker',
            type: 'addressPicker'
          })
          this.attributeOptions = remainData
        }
      })
    },
    // 短信消息模板列表
    getMessageTemplateList() {
      getMessageList().then((res) => {
        for (let item of res.data.data.list) {
          this.eventChangeOptions.push({
            label: item.sms_name,
            value: item.id
          })
        }
      })
    },
    selectAttributeChange(value) {
      this.selectAttribute = null
      for (let item of this.attributeOptions) {
        if (value[0] === item.identity) {
          this.controlType = item.type
          this.selectOptions = item.option
        }
      }
    },
    // 请求微信公众号列表
    getWechatPublicList() {
      getWechatPublicListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.eventChangeOptions.push({
            label: item.nick_name,
            value: item.id
          })
        }
      })
    },
    // 请求微页面列表
    getWePagesList() {
      getWePagesListForNode().then((res) => {
        for (let item of res.data.data.list) {
          this.eventChangeOptions.push({
            label: item.admin_title,
            value: item.id
          })
        }
      })
    },
    getMessageGroupList() {
      getMessageGroupList().then((res) => {
        for (let item of res.data.data.list) {
          this.eventChangeOptions.push({
            label: item.name,
            value: item.id
          })
        }
      })
    },
    // 营销活动 事件列表
    getActivityList() {
      getEventList().then((res) => {
        for (let list of res.data.data.list) {
          for (let one of list.children) {
            one.label = one.name
            one.value = one.identity
          }
        }
        for (let ite of res.data.data.list) {
          if (ite.identity === 'wepage') {
            for (let i in ite.children) {
              if (ite.children[i].identity === 'wepage_forward_to_wechat') {
                ite.children.splice(i, 1)
              }
              if (ite.children[i].identity === 'wepage_forward_to_we_friend') {
                ite.children.splice(i, 1)
              }
            }
          }
        }
        for (let item of res.data.data.list) {
          if (item.identity === 'member') {
            continue
          }
          this.activityOptions.push({
            value: item.identity,
            label: item.name,
            children: item.children
          })
        }
      })
    },
    // 实时营销事情发生部分属性
    activitySelectChange(value) {
      console.log(value)
      this.subSelectedEvent = ''
      this.eventChangeOptions = []
      if (value[0] === 'wechat') {
        this.eventSelectShow = true
        this.getWechatPublicList()
      } else if (value[0] === 'wepage') {
        this.eventSelectShow = true
        this.getWePagesList()
      } else if (value[0] === 'sms') {
        this.eventSelectShow = true
        this.getMessageTemplateList()
      } else if (value[0] === 'order') {
        this.eventSelectShow = false
      } else if (value[0] === 'member' || value[0] === 'user_defined_event') {
        this.eventSelectShow = false
      } else if (value[0] === 'Interactive_activities') {
        this.selectShow = true
        this.loadBigWheelList()
      }
    },
    // 请求大转盘列表
    loadBigWheelList() {
      getBigWheelList({ status: 1 }).then((res) => {
        for (let item of res.data.data.list) {
          this.eventChangeOptions.push({
            label: item.name,
            value: item.id
          })
        }
      })
    },
    // 开始弹窗切换属性清空
    selectRadioChange() {
      if (this.selectRadio === 0) {
        // 属性清空
        this.attributeSelect = false
        this.attrSelectedOptions = []
        this.relationSelect = ''
        this.selectAttribute = ''
        // 客户活跃度清空
        this.selectActivityChange = ''
        this.selectUpAndDown = ''
        this.activityNum = ''
      } else if (this.selectRadio === 1) {
        // 事情发生清空
        this.selectedOptions = []
        this.eventChangeOptions = []
        this.subSelectedEvent = ''
        this.checked = false
        // 属性清空
        this.attributeSelect = false
        this.attrSelectedOptions = []
        this.relationSelect = ''
        this.selectAttribute = ''
      } else if (this.selectRadio === 2) {
        // 事情发生清空
        this.selectedOptions = []
        this.eventChangeOptions = []
        this.subSelectedEvent = ''
        this.checked = false
        // 客户活跃度清空
        this.selectActivityChange = ''
        this.selectUpAndDown = ''
        this.activityNum = ''
      }
    },
    // 打开流程开始弹窗
    openEditFirst() {
      this.createdAutoProcressDialog = true
      let id = this.$route.query.id
      // 如果id存在就是编辑
      if (id) {
        if (this.isFirst === false) {
          if (this.startType === 0) {
            if (this.selectRadio === 0) {
              this.checked = this.firstStep.eventLimit
              this.selectedOptions = this.firstStep.eventNames
              this.subSelectedEvent = this.firstStep.eventContent
            } else if (this.selectRadio === 1) {
              // this.selectActivityChange = this.firstStep.activityType
              this.selectUpAndDown = this.firstStep.activityRelationship
              this.activityNum = this.firstStep.activityNum
            } else if (this.selectRadio === 2) {
              this.attributeSelect = this.firstStep.eventLimit
              this.attrSelectedOptions = this.firstStep.attrNames
              this.relationSelect = this.firstStep.attrRelationship
              this.selectAttribute = this.firstStep.attrContent
              this.controlType = this.firstStep.attrShowType
            }
          } else if (this.startType === 2) {
            this.dateRadio = this.firstStep.dateMethod
            this.timeValue.weekNum = this.firstStep.weekNum
            this.timeValue.dayNum = this.firstStep.dayNum
            this.timeValue.monthNum = this.firstStep.monthNum
            this.timeValue.yearDayNum = this.firstStep.yearDayNum
            this.timeValue.dayOne = this.firstStep.dayOne
            let start = this.filterTime(this.firstStep.startEnd[0])
            let end = this.filterTime(this.firstStep.startEnd[1])
            let mainTime = this.filterTime(this.firstStep.realTime)
            let timeUse = []
            timeUse.push(start)
            timeUse.push(end)
            this.startEnd = timeUse
            this.realTime = mainTime
          }
        }
      } else {
        // 否则就是新建(新建第一次进来点击编辑开始节点)
        this.flowChartForm.queryGroup = this.startCondition.query_id
        this.flowChartForm.procressName = this.startCondition.name
        if (this.startCondition.type === 0) {
          this.startType = 0
          if (this.startCondition.actualContent.triggerConditions === 'event') {
            this.selectRadio = 0
            this.checked = this.startCondition.actualContent.eventLimit
            this.selectedOptions = this.startCondition.actualContent.eventNames
            this.activitySelectChange(this.startCondition.actualContent.eventNames)
            this.subSelectedEvent = this.startCondition.actualContent.eventContent
          } else if (this.startCondition.actualContent.triggerConditions === 'activity') {
            this.selectRadio = 1
            // this.selectActivityChange = this.startCondition.actualContent.activityType
            this.selectUpAndDown = this.startCondition.actualContent.activityRelationship
            this.activityNum = this.startCondition.actualContent.activityNum
          } else if (this.startCondition.actualContent.triggerConditions === 'attr') {
            this.selectRadio = 2
            this.attributeSelect = this.startCondition.actualContent.eventLimit
            this.attrSelectedOptions = this.startCondition.actualContent.attrNames
            this.relationSelect = this.startCondition.actualContent.attrRelationship
            this.selectAttribute = this.startCondition.actualContent.attrContent
            this.controlType = this.startCondition.actualContent.attrShowType
          }
        } else if (this.startCondition.type === 2) {
          this.startType = 2
          this.dateRadio = this.startCondition.actualContent.dateMethod
          this.dayRadio = this.startCondition.actualContent.dateMethod
          this.timeValue.weekNum = this.startCondition.actualContent.weekNum
          this.timeValue.dayNum = this.startCondition.actualContent.dayNum
          this.timeValue.monthNum = this.startCondition.actualContent.monthNum
          this.timeValue.yearDayNum = this.startCondition.actualContent.yearDayNum
          this.timeValue.dayOne = this.startCondition.actualContent.dayOne
          let start = this.filterTime(this.startCondition.actualContent.startEnd[0])
          let end = this.filterTime(this.startCondition.actualContent.startEnd[1])
          let mainTime = this.filterTime(this.startCondition.actualContent.realTime)
          let timeUse = []
          timeUse.push(start)
          timeUse.push(end)
          this.startEnd = timeUse
          this.realTime = mainTime
          this.timeShow = this.timeValue
        } else if (this.startCondition.type === 1) {
          this.startType = 1
        }
      }
    },
    // 返回时间
    filterTime(timeStr) {
      if (timeStr === 0) {
        return '----'
      }
      let time = new Date(timeStr * 1000)
      let y = time.getFullYear()
      let m = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)
      let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
      let h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
      let mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
      let s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
      return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s
    },
    // 保存开始节点编辑的内容
    saveFirstStep() {
      let id = this.$route.query.id
      if (id) {
        this.flowName = this.flowChartForm.procressName
        if (this.startType === 0) {
          if (this.selectRadio === 0) {
            this.firstStep.triggerConditions = 'event'
            this.firstStep.eventLimit = this.checked
            this.firstStep.eventNames = this.selectedOptions
            this.firstStep.eventContent = this.subSelectedEvent
          } else if (this.selectRadio === 1) {
            this.firstStep.eventLimit = false
            this.firstStep.triggerConditions = 'activity'
            // this.firstStep.activityType = this.selectActivityChange
            this.firstStep.activityRelationship = this.selectUpAndDown
            this.firstStep.activityNum = this.activityNum
          } else if (this.selectRadio === 2) {
            this.firstStep.triggerConditions = 'attr'
            this.firstStep.eventLimit = this.attributeSelect
            this.firstStep.attrNames = this.attrSelectedOptions
            this.firstStep.attrRelationship = this.relationSelect
            this.firstStep.attrContent = this.selectAttribute
            this.firstStep.attrShowType = this.controlType
          }
        } else if (this.startType === 2) {
          this.firstStep.dateMethod = this.dateRadio
          this.firstStep.weekNum = this.timeValue.weekNum
          this.firstStep.dayNum = this.timeValue.dayNum
          this.firstStep.monthNum = this.timeValue.monthNum
          this.firstStep.yearDayNum = this.timeValue.yearDayNum
          this.firstStep.dayOne = this.timeValue.dayOne
          let timeSetStart = new Date(this.startEnd[0]).getTime() / 1000
          let timeSetEnd = new Date(this.startEnd[1]).getTime() / 1000
          let newStartEnd = []
          newStartEnd.push(timeSetStart)
          newStartEnd.push(timeSetEnd)
          this.firstStep.startEnd = newStartEnd
          let timeSet = new Date(this.realTime).getTime() / 1000
          this.firstStep.realTime = timeSet
        }
        this.isFirst = false
      } else {
        // 新建的时候的编辑
        this.startCondition.query_id = this.flowChartForm.queryGroup
        this.startCondition.name = this.flowChartForm.procressName
        if (this.startType === 0) {
          this.startCondition.type = 0
          if (this.selectRadio === 0) {
            this.startCondition.actualContent.triggerConditions = 'event'
            this.startCondition.actualContent.eventLimit = this.checked
            this.startCondition.actualContent.eventNames = this.selectedOptions
            this.startCondition.actualContent.eventContent = this.subSelectedEvent
          } else if (this.selectRadio === 1) {
            this.startCondition.actualContent.eventLimit = false
            this.startCondition.actualContent.triggerConditions = 'activity'
            // this.startCondition.actualContent.activityType = this.selectActivityChange
            this.startCondition.actualContent.activityRelationship = this.selectUpAndDown
            this.startCondition.actualContent.activityNum = this.activityNum
          } else if (this.selectRadio === 2) {
            this.startCondition.actualContent.triggerConditions = 'attr'
            this.startCondition.actualContent.eventLimit = this.attributeSelect
            this.startCondition.actualContent.attrNames = this.attrSelectedOptions
            this.startCondition.actualContent.attrRelationship = this.relationSelect
            this.startCondition.actualContent.attrContent = this.selectAttribute
            this.startCondition.actualContent.attrShowType = this.controlType
          }
        } else if (this.startType === 2) {
          this.startCondition.type = 2
          this.startCondition.actualContent.dateMethod = this.dateRadio
          this.startCondition.actualContent.weekNum = this.timeValue.weekNum
          this.startCondition.actualContent.dayNum = this.timeValue.dayNum
          this.startCondition.actualContent.monthNum = this.timeValue.monthNum
          this.startCondition.actualContent.yearDayNum = this.timeValue.yearDayNum
          this.startCondition.actualContent.dayOne = this.timeValue.dayOne
          let timeSetStart = ''
          let timeSetEnd = ''
          if (this.startEnd !== null) {
            timeSetStart = new Date(this.startEnd[0]).getTime() / 1000
            timeSetEnd = new Date(this.startEnd[1]).getTime() / 1000
          }
          let newStartEnd = []
          newStartEnd.push(timeSetStart)
          newStartEnd.push(timeSetEnd)
          this.startCondition.actualContent.startEnd = newStartEnd
          let timeSet = new Date(this.realTime).getTime() / 1000
          this.startCondition.actualContent.realTime = timeSet
        } else if (this.startType === 1) {
          this.startCondition.type = 1
        }
        this.flowName = this.startCondition.name
      }
      // 流程检测是否为空
      if (this.flowChartForm.queryGroup === '') {
        _g.toastMsg('error', '发送群组不能为空')
        return
      }
      if (this.flowChartForm.procressName === '') {
        _g.toastMsg('error', '流程名称不能为空')
        return
      }
      if (this.startType === 0 && this.selectRadio === 0) {
        if (this.selectedOptions.length === 0) {
          _g.toastMsg('error', '事件不能为空')
          return
        }
        if (this.subSelectedEvent === '' && this.selectedOptions[0] !== 'order' && this.selectedOptions[0] !== 'member' && this.selectedOptions[0] !== 'user_defined_event') {
          _g.toastMsg('error', '事件内容不能为空')
          return
        }
      }
      if (this.startType === 0 && this.selectRadio === 1) {
        if (this.selectUpAndDown === '') {
          _g.toastMsg('error', '活跃度关系不能为空')
          return
        }
        if (this.activityNum === '') {
          _g.toastMsg('error', '活跃度值不能为空')
          return
        }
      }
      if (this.startType === 0 && this.selectRadio === 2) {
        if (this.attrSelectedOptions.length === 0) {
          _g.toastMsg('error', '属性不能为空')
          return
        }
        if (this.relationSelect === '') {
          _g.toastMsg('error', '属性相对关系不能为空')
          return
        }
        if (this.selectAttribute === '' || this.selectAttribute === null || this.selectAttribute.length === 0) {
          _g.toastMsg('error', '属性值不能为空')
          return
        }
      }
      if (this.startType === 2) {
        if (this.realTime === null) {
          _g.toastMsg('error', '具体时间不能为空')
          return
        }
        if (this.startEnd === null) {
          _g.toastMsg('error', '起止时间不能为空')
          return
        }
      }
      this.createdAutoProcressDialog = false
      this.isHvaeData = true
    },
    // 保存编辑的流程
    saveEdit() {
      if (this.isHvaeData === true) {
        this.treeDataArr[0].content = this.firstStep
      } else {
        this.saveFirstStep()
        this.treeDataArr[0].content = this.firstStep
      }
      for (let one of this.treeDataArr) {
        if (one.shape === 'attrJudgeNode') {
          for (let item of one.content.allTerms.termsGroup) {
            for (let ite of item.terms) {
              ite.option = null
            }
          }
        }
      }
      let id = this.$route.query.id
      editFlowChart(this.flowChartForm.procressName, this.flowChartForm.queryGroup, this.startType, 1, this.treeDataArr, id).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.getActualData()
          this.setConditions({})
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 保存自动化流程
    saveFlowChart() {
      this.treeDataArr[0].content = this.startCondition.actualContent
      console.log('this.treeDataArr', this.treeDataArr)
      for (let one of this.treeDataArr) {
        if (one.shape === 'attrJudgeNode') {
          for (let item of one.content.allTerms.termsGroup) {
            for (let ite of item.terms) {
              ite.option = null
            }
          }
        }
      }
      saveFlowChart(this.startCondition.name, this.startCondition.query_id, this.startCondition.type, 1, this.treeDataArr).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/auto-process')
          this.setConditions({})
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    ...mapMutations([
      'setConditions'
    ]),
    // 判断是什么节点进行显示
    isWhatNode(ev) {
      this.chooseNode = true
      this.openWay = 1
      this.isShow = false
      this.nodeShow = false
      if (this.recordDialog.type === 'nodeAction') {
        this.nodeAction = this.recordDialog.value
      } else if (this.recordDialog.type === 'nodeJudge') {
        this.nodeJudge = this.recordDialog.value
      } else if (this.recordDialog.type === 'nodeControl') {
        this.nodeControl = this.recordDialog.value
      }
    },
    treeNode() {
      let roots = JSON.parse(JSON.stringify(this.treeDataArr))
      return {
        roots: toTree(roots)
      }
    },
    // 添加节点（暂留，取消不用）
    addNode(ev, nodeType) {
      this.changeSize()
      // 实体节点
      let firstNodeId = this.nodeId()
      this.graph.add('node', {
        id: firstNodeId,
        y: ev.y + 100,
        shape: nodeType,
        style: { // 关键形样式（优先级高于color）
          fill: 'transparent',
          stroke: 'transparent'
        }
      })
      this.graph.add('edge', {
        target: firstNodeId,
        source: ev.item.id,
        style: {
          endArrow: true
        },
        label: '箭头'
      })
      let secondNodeId = this.nodeId()
      if (nodeType !== 'endNode') {
        // 加号节点
        this.graph.add('node', {
          id: secondNodeId,
          y: ev.y + 200,
          shape: 'addNodeBtn', // 所用图形
          style: { // 关键形样式（优先级高于color）
            fill: 'transparent',
            stroke: 'transparent'
          }
        })
        this.graph.add('edge', {
          target: secondNodeId,
          source: firstNodeId,
          style: {
            endArrow: true
          },
          label: '箭头'
        })
      }
      this.idArray.push({
        first: firstNodeId,
        second: secondNodeId // secondNodeId
      })
    },
    // 添加节点
    addAction(ev, nodeType, content) {
      this.changeSize()
      // 生成节点id
      let firstNodeId = this.nodeId()
      let secondNodeId = this.nodeId()
      // 处理旧数据的层级关系
      for (let item of this.treeDataArr) {
        if (item.parent === ev.item.id) {
          item.parent = secondNodeId
        }
      }
      // 增加新层级
      content.id = firstNodeId
      this.treeDataArr.push({
        id: firstNodeId,
        shape: nodeType,
        parent: ev.item.id,
        content: content
      })
      if (nodeType !== 'endNode') {
        this.treeDataArr.push({
          id: secondNodeId,
          shape: 'addNodeBtn',
          parent: firstNodeId
        })
      }
      let aa = JSON.parse(JSON.stringify(this.treeDataArr))
      this.idArray.push({
        first: firstNodeId,
        second: secondNodeId // secondNodeId
      })
      this.render()
    },
    /**
     * 添加条件
     * ev 事件对象
     *
     **/
    addCond(ev, nodeType, condition, content) {
      console.log('ev', ev, 'type', nodeType, '11', condition, '22', content)
      this.changeSize()
      // 生成节点id
      let firstNodeId = this.nodeId() // 条件节点
      let conditionNodeIds = [] // 条件分支节点
      for (let con of condition) {
        conditionNodeIds.push({
          id: this.nodeId(),
          shape: 'addNodeBtn',
          parent: firstNodeId,
          condition: con
        })
      }
      // 处理旧数据的层级关系，让以前的子节点全部转移到第一个条件节点下
      for (let item of this.treeDataArr) {
        if (item.parent === ev.item.id) {
          item.parent = conditionNodeIds[0].id
        }
      }
      content.id = firstNodeId
      // 增加条件节点
      this.treeDataArr.push({
        id: firstNodeId,
        shape: nodeType,
        parent: ev.item.id,
        content: content
      })
      // 添加条件分支节点
      for (let item of conditionNodeIds) {
        this.treeDataArr.push(item)
      }
      let aa = JSON.parse(JSON.stringify(this.treeDataArr))
      this.render()
      this.idArray.push({
        first: firstNodeId,
        conditionNodeIds: conditionNodeIds // secondNodeId
      })
    },
    // 渲染流程图
    render() {
      // 渲染流程图
      this.graph.read(this.treeNode())
      // 处理连线
      let edges = this.graph.getEdges()
      for (let item of this.treeDataArr) {
        if (item.condition) {
          // 如果有分支条件则查找，该节点为目标的连线，将条件展示处理
          let edge = edges.find(function(element) {
            return element.target.id == item.id
          })
          if (edge) {
            this.graph.update(edge.id, { label: item.condition })
          }
        }
      }
    },
    // 拖动处理
    drag() {
      let node
      let dx
      let dy
      this.graph.on('node:dragstart', ev => {
        const {item} = ev
        const model = item.getModel()
        node = item
        dx = model.x - ev.x
        dy = model.y - ev.y
      })
      this.graph.on('node:drag', ev => {
        node && this.graph.update(node, {
          x: ev.x + dx,
          y: ev.y + dy
        })
      })
      this.graph.on('node:dragend', ev => {
        node = undefined
      })
    },
    // 点击处理
    click() {
      this.graph.on('node:click', ev => {
        // 如果是添加按钮  打开弹窗选择
        if (ev.item.model.shape === 'addNodeBtn') {
          this.evs = ev
          this.chooseNode = true
          this.openWay = 0
          this.isShow = true
          this.clear()
        }
        // this.graph.layout()
      })
    },
    // 清空
    clear() {
      // 清空
      this.nodeShow = true
      this.nodeAction = ''
      this.nodeJudge = ''
      this.nodeControl = ''
      this.smsContent = {
        id: '',
        name: '短信',
        template_id: ''
      }
      this.wechatReplyContent = {
        name: '微信回复',
        wechatId: '',
        contentType: 'text',
        content: '',
        wePage: '',
        big_wheel: '',
        link: '',
        title: '',
        main: '',
        id: ''
      }
      this.customerAttrContent = {
        attrId: '',
        attrVal: null,
        name: '客户属性',
        id: ''
      }
      this.addGroupContent = {
        name: '加入群组',
        addGroupId: '',
        id: ''
      }
      this.removeGroupContent = {
        name: '移除群组',
        removeGroupId: '',
        id: ''
      }
      this.templateMessageContent = {
        name: '模板消息',
        wechatPublicId: '',
        messageId: '',
        useList: [],
        id: ''
      }
      this.sendRedPacketsContent = {
        wechatId: '',
        sendMessage: '发送红包',
        name: '',
        remark: '',
        activityName: '',
        goodLuck: '',
        num: 0,
        id: ''
      }
      this.attrJudgeContent = {
        id: '',
        nodeType: '',
        allTerms: {
          allRelationship: 'and',
          termsGroup: [
            {
              inOperator: 'and',
              terms: [
                {
                  attr: 'attr',
                  relationship: '',
                  value: null,
                  selectedOptions: ['attr', 'realname@input'],
                  secAttr: 'realname'
                }
              ]
            }
          ]
        }
      }
      this.eventsContent = {
        day: 0,
        hours: 0,
        mins: 0,
        id: '',
        nodeType: '',
        content: [
          {
            conditionIndex: 1,
            selectedOptions: [],
            selectShow: true,
            subSelectedOptions: '',
            changeOptions: []
          }
        ]
      }
      this.attrBranchContent = {
        id: '',
        attrId: '',
        nodeType: '',
        conditionValue: '',
        content: [
          {
            branchIndex: 1,
            value: ''
          }
        ]
      }
      this.waitTime = {
        waitType: 0,
        day: 0,
        hours: 0,
        mins: 0,
        confirmTime: '',
        relatime: '',
        id: ''
      }
      this.endContent = {
        id: '',
        nodeType: 'endNode'
      }
    },
    // 分析是哪个节点要添加 进行添加
    confirmAddNode() {
      // 微信回复
      if (this.nodeAction === 0) {
        if (this.openWay === 0) {
          if (this.wechatReplyContent.wechatId === '') {
            _g.toastMsg('error', '请选择公众号')
            return
          }
          this.addAction(this.evs, this.wechatReplyContent.nodeType, this.wechatReplyContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          if (this.wechatReplyContent.wechatId === '') {
            _g.toastMsg('error', '请选择公众号')
            return
          }
          for (let item of this.treeDataArr) {
            if (item.id === this.wechatReplyContent.id) {
              item.content = this.wechatReplyContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
        // let msgtype = ''
        // if (this.wechatReplyContent.contentType === 0) {
        // msgtype = 'text'
        // } else if (this.wechatReplyContent.contentType === 1) {
        // msgtype = 'image'
        // } else if (this.wechatReplyContent.contentType === 2) {
        // msgtype = 'mpnews'
        // } else if (this.wechatReplyContent.contentType === 3) {
        // msgtype = 'news'
        // }
        // autoFlowWechatReply(this.wechatReplyContent.name, this.wechatReplyContent.wechatId, msgtype, this.wechatReplyContent.content, this.wechatReplyContent.imageUrl, this.wechatReplyContent.title, this.wechatReplyContent.coverUrl, this.wechatReplyContent.main, this.wechatReplyContent.link).then((res) => {
        // if (res.data.code === 0) {}
        // })
      }
      // 短信
      if (this.nodeAction === 1) {
        if (this.openWay === 0) {
          if (this.smsContent.template_id === '') {
            _g.toastMsg('error', '请选择短信')
            return
          }
          this.addAction(this.evs, this.smsContent.nodeType, this.smsContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.smsContent.id) {
              item.content = this.smsContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 客户属性
      if (this.nodeAction === 2) {
        if (this.openWay === 0) {
          if (this.customerAttrContent.attrId === '') {
            _g.toastMsg('error', '请选择客户属性')
            return
          }
          if (this.customerAttrContent.attrVal === '' || this.customerAttrContent.attrVal === null) {
            _g.toastMsg('error', '请输入客户属性值')
            return
          }
          this.addAction(this.evs, this.customerAttrContent.nodeType, this.customerAttrContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.customerAttrContent.id) {
              item.content = this.customerAttrContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 加入群组
      if (this.nodeAction === 3) {
        if (this.openWay === 0) {
          if (this.addGroupContent.addGroupId === '') {
            _g.toastMsg('error', '请选择群组')
            return
          }
          this.addAction(this.evs, this.addGroupContent.nodeType, this.addGroupContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.addGroupContent.id) {
              item.content = this.addGroupContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 移出群组
      if (this.nodeAction === 4) {
        if (this.openWay === 0) {
          if (this.removeGroupContent.removeGroupId === '') {
            _g.toastMsg('error', '请选择群组')
            return
          }
          this.addAction(this.evs, this.removeGroupContent.nodeType, this.removeGroupContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.removeGroupContent.id) {
              item.content = this.removeGroupContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 模板消息
      if (this.nodeAction === 5) {
        if (this.openWay === 0) {
          if (this.templateMessageContent.wechatPublicId === '') {
            _g.toastMsg('error', '请选择微信账号')
            return
          }
          if (this.templateMessageContent.messageId === '') {
            _g.toastMsg('error', '请选择模板')
            return
          }
          this.addAction(this.evs, this.templateMessageContent.nodeType, this.templateMessageContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.templateMessageContent.id) {
              item.content = this.templateMessageContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 发送红包
      if (this.nodeAction === 6) {
        if (this.openWay === 0) {
          if (this.sendRedPacketsContent.wechatId === '') {
            _g.toastMsg('error', '请选择商户')
            return
          }
          if (this.sendRedPacketsContent.name === '') {
            _g.toastMsg('error', '请输入商户名称')
            return
          }
          if (this.sendRedPacketsContent.num === undefined) {
            _g.toastMsg('error', '请输入红包金额')
            return
          }
          if (this.sendRedPacketsContent.goodLuck === '') {
            _g.toastMsg('error', '请输入祝福语')
            return
          }
          this.addAction(this.evs, this.sendRedPacketsContent.nodeType, this.sendRedPacketsContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          if (this.sendRedPacketsContent.num === undefined) {
            _g.toastMsg('error', '请输入红包金额')
            return
          }
          if (this.sendRedPacketsContent.goodLuck === '') {
            _g.toastMsg('error', '请输入祝福语')
            return
          }
          for (let item of this.treeDataArr) {
            if (item.id === this.sendRedPacketsContent.id) {
              item.content = this.sendRedPacketsContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 属性判断
      if (this.nodeJudge === 0) {
        if (this.openWay === 0) {
          let count = 0
          console.log('22', this.attrJudgeContent.allTerms.termsGroup)
          for (let i in this.attrJudgeContent.allTerms.termsGroup) {
            for (let j in this.attrJudgeContent.allTerms.termsGroup[i].terms) {
              if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].selectedOptions[0] === 'attr') {
                if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].relationship === '') {
                  _g.toastMsg('error', '请选择相对关系')
                  return
                }
              }
              if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].relationship !== 'empty' && this.attrJudgeContent.allTerms.termsGroup[i].terms[j].relationship !== 'not empty') {
                if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].value === '' || this.attrJudgeContent.allTerms.termsGroup[i].terms[j].value === null) {
                  _g.toastMsg('error', '查询值不能为空')
                  return
                }
              }
            }
          }
          this.addCond(this.evs, this.attrJudgeContent.nodeType, ['是', '否'], this.attrJudgeContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let i in this.attrJudgeContent.allTerms.termsGroup) {
            for (let j in this.attrJudgeContent.allTerms.termsGroup[i].terms) {
              if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].selectedOptions[0] === 'attr') {
                if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].relationship === '') {
                  _g.toastMsg('error', '请选择相对关系')
                  return
                }
              }
              if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].relationship !== 'empty' && this.attrJudgeContent.allTerms.termsGroup[i].terms[j].relationship !== 'not empty') {
                if (this.attrJudgeContent.allTerms.termsGroup[i].terms[j].value === '' || this.attrJudgeContent.allTerms.termsGroup[i].terms[j].value === null) {
                  _g.toastMsg('error', '查询值不能为空')
                  return
                }
              }
            }
          }
          for (let item of this.treeDataArr) {
            if (item.id === this.attrJudgeContent.id) {
              item.content = this.attrJudgeContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 事件判断
      if (this.nodeJudge === 1) {
        if (this.openWay === 0) {
          if (this.eventsContent.content[0].selectedOptions.length === 0) {
            _g.toastMsg('error', '请选择事件')
            return
          }
          if (this.eventsContent.content[0].selectedOptions[0] !== 'user_defined_event' && this.eventsContent.content[0].selectedOptions[0] !== 'member' && this.eventsContent.content[0].selectedOptions[0] !== 'order' && this.eventsContent.content[0].subSelectedOptions === '') {
            _g.toastMsg('error', '请选择事件参数')
            return
          }
          this.addCond(this.evs, this.eventsContent.nodeType, ['是', '否'], this.eventsContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.eventsContent.id) {
              item.content = this.eventsContent
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 属性多分支
      if (this.nodeJudge === 2) {
        if (this.openWay === 0) {
          if (this.attrBranchContent.attrId === '') {
            _g.toastMsg('error', '请选择属性')
            return
          }
          if (this.attrBranchContent.conditionValue === '') {
            _g.toastMsg('error', '请选择属性相对关系')
            return
          }
          let newArr = []
          for (let item of this.attrBranchContent.content) {
            if (item.value === '') {
              _g.toastMsg('error', '分支不能为空')
              return
            }
            newArr.push(item.value)
            // this.clear()
          }
          newArr.push('其他')
          this.addCond(this.evs, this.attrBranchContent.nodeType, newArr, this.attrBranchContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            // item.arrs = []
            if (item.id === this.attrBranchContent.id) {
              item.content = this.attrBranchContent
              for (let a of this.attrBranchContent.content) {
                if (a.value === '') {
                  _g.toastMsg('error', '分支不能为空')
                  return
                }
              }
              this.treeDataArrCopy = JSON.parse(JSON.stringify(this.treeDataArr))
              if (this.evAttrBranch.shape.id === item.id) {
                item.result = []
                item.contentArr = JSON.parse(JSON.stringify(item.content.content))
                console.log('0001', item.contentArr)
                // 编辑回显刷新流程图
                for (let k = this.treeDataArrCopy.length - 1; k >= 0; k--) {
                  if (item.id === this.treeDataArrCopy[k].parent) {
                    this.treeDataArr.splice(k, 1)
                  }
                }
                // 数组去重
                item.contentArr.push({
                  branchIndex: '',
                  value: '其他'
                })
                for (let i of item.contentArr) {
                  item.result.push(i.value)
                }
                // 开始组织子节点
                let conditionNodeIds = []
                for (let con of item.result) {
                  conditionNodeIds.push({
                    id: this.nodeId(),
                    shape: 'addNodeBtn',
                    parent: item.id,
                    condition: con
                  })
                }
                // 添加条件分支节点
                for (let items of conditionNodeIds) {
                  this.treeDataArr.push(items)
                }
                this.render()
                console.log('item.result', item.result)
                console.log('arrs', this.treeDataArr)
              }
            }
          }
          console.log('0003', this.treeDataArr)
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 等待
      if (this.nodeControl === 0) {
        if (this.openWay === 0) {
          if (this.waitTime.waitType === 0) {
            if (this.waitTime.day === 0 && this.waitTime.hours === 0 && this.waitTime.mins === 0) {
              _g.toastMsg('error', '请填写时间')
              return
            }
            if (this.waitTime.day === undefined && this.waitTime.hours === undefined && this.waitTime.mins === undefined) {
              _g.toastMsg('error', '请填写时间')
              return
            }
          } else {
            if (this.waitTime.confirmTime === '') {
              _g.toastMsg('error', '请填写时间')
              return
            }
          }
          this.addAction(this.evs, this.waitTime.nodeType, this.waitTime)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          for (let item of this.treeDataArr) {
            if (item.id === this.waitTime.id) {
              item.content = this.waitTime
            }
          }
          this.chooseNode = false
          this.isShow = true
        }
        this.clear()
      }
      // 结束
      if (this.nodeControl === 1) {
        if (this.openWay === 0) {
          this.speNodeType = this.endContent.nodeType
          this.addAction(this.evs, this.endContent.nodeType, this.endContent)
          this.chooseNode = false
          this.openWay = 2
        } else if (this.openWay === 1) {
          this.chooseNode = false
          this.isShow = true
          return
        }
        this.clear()
      }
    },
    // 生成nodeid
    nodeId() {
      let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
      let nodeName = 'node-'
      for (let i = 0; i < 6; i++) {
        nodeName = nodeName + chars[parseInt(Math.random() * 16)]
      }
      return nodeName
    },
    // 改变画布高度
    changeSize() {
      this.graph.changeSize(this.graph.getWidth(), this.graph.getHeight() + 250)
      console.log('101', this.graph.getHeight())
    },
    // 切换大的节点类型
    changeTabs(index) {
      this.tabIndex = index
      if (this.tabIndex === 0) {
        this.specialClass = 'active-one'
      } else if (this.tabIndex === 1) {
        this.specialClass = 'active-two'
      } else {
        this.specialClass = 'active-three'
      }
      // 只要切换这个大的导航 就进行清空(记得在打开弹窗的时候再清空一遍)
      this.clear()
    },
    // 切换动作
    changeAction(index) {
      this.nodeAction = index
      this.nodeShow = false
    },
    // 切换判断
    changeJudge(index) {
      this.nodeJudge = index
      this.nodeShow = false
    },
    // 切换流程控制
    changeControl(index) {
      this.nodeControl = index
      this.nodeShow = false
    },
    // 获取短信子组件的值
    getSmsChoose(value) {
      this.smsContent = value
    },
    // 获取微信回复子组件的值
    getWechatReply(value) {
      this.wechatReplyContent = value
    },
    // 获取客户属性子组件值
    getCustomerAttr(value) {
      this.customerAttrContent = value
    },
    // 获取加入群组子组件的值
    getAddGroup(value) {
      this.addGroupContent = value
    },
    // 获取移出群组子组件的值
    getRemoveGroup(value) {
      this.removeGroupContent = value
    },
    // 获取模板消息子组件的值
    getTemplateMessage(value) {
      this.templateMessageContent = value
    },
    // 获取发送红包子组件的值
    getSendRedPackets(value) {
      this.sendRedPacketsContent = value
    },
    // 获取属性判断子组件的值
    getSearchTerms(value) {
      this.attrJudgeContent = value
      console.log('attr', this.attrJudgeContent)
    },
    // 获取事件判断子组件的值
    getEvents(value) {
      this.eventsContent = value
      console.log('this.eventsContent', this.eventsContent)
    },
    // 获取属性多分支子组件的值
    getAttrBranch(value) {
      this.attrBranchContent = value
      console.log('00002', this.attrBranchContent)
    },
    // 获取等待时间
    getWait(value) {
      this.waitTime = value
    },
    // 获取结束节点值
    getEnd(value) {
      this.endContent = value
    },
    // 获取自动化流程回显数据
    getActualData() {
      let id = this.$route.query.id
      getFlowChartDetail(id).then((res) => {
        if (res.data.code === 0) {
          let item = res.data.data
          this.treeDataArr = item.condition
          this.btnJudge = item.status
          this.flowName = item.name
          this.startType = item.type
          // 开始节点回显
          this.flowChartForm.queryGroup = item.query_id
          this.flowChartForm.procressName = item.name
          if (item.type === 2) {
            this.dateRadio = this.treeDataArr[0].content.dateMethod
            this.dayRadio = this.treeDataArr[0].content.dateMethod
            let start = this.filterTime(this.treeDataArr[0].content.startEnd[0])
            let end = this.filterTime(this.treeDataArr[0].content.startEnd[1])
            let mainTime = this.filterTime(this.treeDataArr[0].content.realTime)
            let timeUse = []
            timeUse.push(start)
            timeUse.push(end)
            this.realTime = mainTime
            this.startEnd = timeUse
            this.timeShow.dayNum = this.treeDataArr[0].content.dayNum
            this.timeShow.dayOne = this.treeDataArr[0].content.dayOne
            this.timeShow.monthNum = this.treeDataArr[0].content.monthNum
            this.timeShow.weekNum = this.treeDataArr[0].content.weekNum
            this.timeShow.yearDayNum = this.treeDataArr[0].content.yearDayNum
          } else if (item.type === 0) {
            if (this.treeDataArr[0].content.triggerConditions === 'event') {
              this.selectRadio = 0
              this.checked = this.treeDataArr[0].content.eventLimit
              this.selectedOptions = this.treeDataArr[0].content.eventNames
              this.activitySelectChange(this.treeDataArr[0].content.eventNames)
              this.subSelectedEvent = this.treeDataArr[0].content.eventContent
            } else if (this.treeDataArr[0].content.triggerConditions === 'activity') {
              this.selectRadio = 1
              // this.selectActivityChange = this.treeDataArr[0].content.activityType
              this.selectUpAndDown = this.treeDataArr[0].content.activityRelationship
              this.activityNum = this.treeDataArr[0].content.activityNum
            } else if (this.treeDataArr[0].content.triggerConditions === 'attr') {
              this.attributeSelect = this.treeDataArr[0].content.eventLimit
              this.attrSelectedOptions = this.treeDataArr[0].content.attrNames
              this.relationSelect = this.treeDataArr[0].content.attrRelationship
              this.selectAttribute = this.treeDataArr[0].content.attrContent
              this.controlType = this.treeDataArr[0].content.attrShowType
              this.selectRadio = 2
            }
          }
          this.graph.changeSize(this.graph.getWidth(), this.graph.getHeight() + 150 * (this.treeDataArr.length - 3))
          this.render()
        }
      })
    },
    // 获取群组列表
    loadCustomerGroup() {
      getGroupList().then((res) => {
        if (res.data.code === 0) {
          this.targetGroups = res.data.data.list
        }
      })
    }
  },
  created() {
    // 获取创建流程发送过来的条件数据
    this.startCondition = JSON.parse(window.sessionStorage.getItem('conditions'))
    let id = this.$route.query.id
    if (id) {
      this.getActualData()
    } else {
      this.flowName = this.startCondition.name
    }
    this.getActivityList()
    this.getCustomerAttributeList()
    this.loadCustomerGroup()
  },
  components: {
    wechatReply,
    customerAttribute,
    templateMessage,
    removeGroup,
    addGroup,
    sendRedPackets,
    message,
    attrJudge,
    eventJudge,
    attributeBranch,
    wait,
    end,
    DateTemplateEdit
  }
}
</script>

<style scoped>
  .flow-name{
    width: calc(100% - 60px);
    height: 50px;
    background: #fff;
    line-height: 50px;
    text-align: left;
    padding-left: 20px;
    color: #000;
    margin: 20px auto 0;
    border: 1px solid #E7E7E7;
    border-bottom: none;
    box-sizing: content-box;
  }
  #mountNode{background: #fff;border: 1px solid #ebebeb;width: calc(100% - 40px);margin: 0 auto}
  .top-nav{
    height: 42px;
    display: flex;
    justify-content: flex-start;
  }
  .top-nav div{
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    width: 152px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .top-nav div:first-child{
    border-left: 1px solid #ccc;
  }
  .active-one{
    background: #4DA2ED;
    color: #fff;
  }
  .active-two{
    background: #D893F2;
    color: #fff;
  }
  .active-three{
    background: #FF8888;
    color: #fff;
  }
  .bottom-content{
    overflow: hidden;
    padding-top: 20px;
  }
  .node-item{
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    float: left;
    cursor: pointer;
  }
  .node-item-icon{
    width: 45px;
    height: 45px;
    border-radius: 10px;
    background: #4DA2ED;
    color: #fff;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    margin-bottom: 10px;
  }
  .node-item-one:hover .node-item-icon{
    -moz-box-shadow:0 0 18px #4DA2ED;
    -webkit-box-shadow:0 0 18px #4DA2ED;
    box-shadow:0 0 18px #4DA2ED;
  }
  .node-item-two:hover .node-item-icon{
    -moz-box-shadow:0 0 18px #D893F2;
    -webkit-box-shadow:0 0 18px #D893F2;
    box-shadow:0 0 18px #D893F2;
  }
  .node-item-three:hover .node-item-icon{
    -moz-box-shadow:0 0 18px #FF8888;
    -webkit-box-shadow:0 0 18px #FF8888;
    box-shadow:0 0 18px #FF8888;
  }
  .info-operation{
    width: calc(100% - 40px);
    margin: 20px auto 0;
    height: 50px;
    background: #fff;
    border: 1px solid #ebebeb;
  }
  .info-operation .flow-chart-name{
    float: left;
    line-height: 50px;
    margin-left: 20px;
  }
  .info-operation .flow-chart-opertions{
    float: right;
    margin-right: 20px;
  }
  .flow-chart-opertions div{
    float: left;
    width: 80px;
    height: 50px;
    text-align: center;
    cursor: pointer;
    margin-left: 10px;
  }
  .flow-chart-opertions i, .flow-chart-opertions span{
    display: block;
    height: 25px;
    line-height: 25px;
  }
</style>
